import Vue from 'vue'
import Router from 'vue-router'
import maping from './meta.js'

import index from '@/page/index.html'
import product from '@/page/product/product.html'
import productCase from '@/page/product/_id'
import service from '@/page/service.html'
import news from '@/page/news/company-news.html'
import industryNews from '@/page/news/industry-news.html'
import commonSense from '@/page/news/common-sense.html'
import newsDetail from '@/page/news/_id'
import about from '@/page/about.html'

import contact from '@/page/contact.html'
import strength from '@/page/strength.html'

import search from '@/page/search.html'

Vue.use(Router);

// Router.beforeEach((to, from, next) => {
//   window.scrollTo(0,0)
// });

const router = new Router({
  // mode: 'history',
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
      meta: maping.index,
    },
    {
      path: '/index.html',
      name: 'index',
      component: index,
      meta: maping.index,
    },
	{
	  path: '/search.html',
	  name: 'search',
	  component: search
	},
    {
      path: '/product.html',
      name: 'product',
      component: product
    },
    {
      path: '/product/:id.html',
      name: 'productCase',
      component: productCase
    },
    {
      path: '/service.html',
      name: 'service',
      component: service
    },
    {
      path: '/news.html',
      name: 'news',
      component: news
    },
    {
      path: '/industryNews.html',
      name: 'industryNew',
      component: industryNews
    },
    {
      path: '/commonSense.html',
      name: 'commonSense',
      component: commonSense
    },
    {
      path: '/news/detail-:cid-:id.html',
      name: 'newsDetail',
      component: newsDetail
    },
    {
      path: '/about.html',
      name: 'about',
      component: about
    },
    {
      path: '/contact.html',
      name: 'contact',
      component: contact
    },
    {
      path: '/strength.html',
      name: 'strength',
      component: strength
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    // 页面切换滚动到顶部
    return { x: 0, y: 0 }
  }
});

router.beforeEach((to, from, next) => {

  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  // console.log(previousNearestWithMeta);

  if(nearestWithTitle) document.title = nearestWithTitle.meta.title;

  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  if(!nearestWithMeta) return next();

  nearestWithMeta.meta.metaTags.map(tagDef => {

    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });

    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  }).forEach(tag => document.head.appendChild(tag));

  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js